import { DatasetKeyVariableDefinition } from "./dataset-key-variable-definition";

export interface DatasetKeyDefinition {
    name: string;
    description: string | null;
    variables: DatasetKeyVariableDefinition[];
}
